<div class="p-6">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
    <h3 class="font-bold">{{ '::Wineries' | abpLocalization }}</h3>
    <app-metro-button
      variant="secondary"
      text="{{ '::AddWinery' | abpLocalization }}"
      (clicked)="openCreateModal()"
    >
    </app-metro-button>
  </div>

  <div class="flex flex-col mt-3">
    <app-metro-search-input (search)="onSearch($event)"
          (cleared)="onClearSearch()"></app-metro-search-input>
  </div>

  <div class="flex flex-col overflow-x-auto rounded-lg border-1 border-gray-700">
    @if (isLoading) {
      <app-metro-table-skeleton [columns]="columns"></app-metro-table-skeleton>
    } @else {
      <app-metro-table [columns]="columns" [data]="data.items" [actions]="actions" [pageSize]="10"
        [currentPage]="list.page + 1" (pageChange)="onPageChange($event)" [isServerPaginated]="true" [totalItems]="data.totalCount">
      </app-metro-table>
    }
  </div>
</div>
